/** @jsx jsx */
// External libraries
import { jsx } from '@emotion/core';

// Internal modules
import { features } from '@/lib';
import { sectionStyles } from './styles';
import { CountryDropdown } from '../Locale';
import { PaymentSectionHeading } from './PaymentSectionHeading';
import { LazyCardFields, LazyTabbedBankAndCardFields } from './LazyComponents';

const PaymentInformation = () => {
  const hasBank = features.someActive('hasAddBank', 'hasConsumerAddBank');

  return (
    <section css={sectionStyles}>
      <PaymentSectionHeading />

      <CountryDropdown />

      {hasBank ? <LazyTabbedBankAndCardFields /> : <LazyCardFields />}
    </section>
  );
};

export { PaymentInformation };
